module.exports = __webpack_public_path__ + "7001c8db2de709c8bd41793ae598050b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/font_uzv8nkw1nabgldi.eot
// module id = 839
// module chunks = 0